import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import useDesignTokens from '../../../themes/useDesignTokens';

const useErrorMessageStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      errorMessage: {
        paddingLeft: theme.sizeGuide.lg,
      },
      pipe: {
        color: tokens.colors.text.placeholder,
      },
      linkText: {
        color: tokens.components.button.link.default.fg.default,
        cursor: 'pointer',
      },
    }),
    [theme, tokens],
  );

  return styles;
};

export default useErrorMessageStyles;
